<script>
    import {onMount} from "svelte";
    import gsap from "gsap";
    import {mainTimeline} from "../../timelines/main-timeline";

    export let activeTimes = [];
    export let spinningTimes = [];
    export let liftTimes = [];
    export let stopSpinScenes = [];
    export let scene = 0;
    export let clickableScenes = [];

    let active = false;

    // Element references
    let outerBoxGroup;
    let boxGroup;
    let spin;
    let outerSpin;

    let frontFace;
    let backFace;
    let rightFace;
    let leftFace;
    let topFace;
    let bottomFace;

    function makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() *
                charactersLength));
        }
        return result;
    }

    const id = makeid();

    $: spinActive = !stopSpinScenes.includes(scene);
    $: borderColour = clickableScenes.includes(scene) ? 'white' : 'black';

    const duration = 6;

    function addSpinBounce() {
        const tl = gsap.timeline({repeat: -1});

        tl.seek(Math.random() * duration);

        tl.to(boxGroup, {
            translateY: '-15px',
            ease: 'bounceInOut',
            duration: duration / 2,
        }, 0).to(boxGroup, {
            translateY: '0',
            ease: 'bounceInOut',
            duration: duration / 2,
        }, duration / 2);
    }

    function addActiveTimeline() {

        const boxFaces = [frontFace, backFace, rightFace, leftFace, topFace, bottomFace];

        activeTimes.forEach((times) => {
            mainTimeline
                .to(boxFaces, {
                    borderColor: 'rgb(255 136 51)',
                }, times[0])
                .to(outerBoxGroup, {
                    scale: 1.2,
                }, times[0])
                .to(boxFaces, {
                    borderColor: 'inherit',
                }, times[1])
                .to(outerBoxGroup, {
                    scale: 0.9,
                }, times[1]);
        });

        spinningTimes.forEach((times) => {
            mainTimeline
                .to(outerSpin, {
                    rotateY: 375,
                    duration,
                }, times[0])
                .to(outerSpin, {
                    rotateY: -375,
                    duration,
                }, times[1]);
        });

        liftTimes.forEach((times) => {
            mainTimeline
                .to(outerBoxGroup, {
                    translateY: '-50px',
                    ease: 'bounceInOut',
                    duration: duration / 2,
                }, times[0])
                .to(outerBoxGroup, {
                    translateY: '0px',
                    ease: 'bounceInOut',
                    duration: duration / 2,
                }, times[1])

        });
    }

    onMount(addActiveTimeline);

</script>

<div bind:this={outerBoxGroup}>
    <div bind:this={boxGroup} class="box-group">
        <div class="scene">
            <svg viewBox="0 0 600 600" height="600" width="600" overflow="visible" class="glowSvg">
                <defs>
                    <radialGradient id="blueGlowSmall">
                        <stop offset="0%" stop-color="rgba(255, 255, 255, 1)"/>
                        <stop offset="90%" stop-color="rgba(255, 255, 255, 0.05)"/>
                        <stop offset="100%" stop-color="rgba(255, 255, 255, 0)"/>
                    </radialGradient>
                </defs>
                <circle class=glow2 cx="150" cy="150" r="200" fill="url('#blueGlowSmall')"/>
            </svg>
            <div style="transform: rotateY(103deg); transform-style: preserve-3d;" >
                <div class="spin2" bind:this={outerSpin}>
                    <div class:bounce-active={spinActive}
                         style="--delay: { - Math.random() * 3}; transform-style: preserve-3d;">
                        <div class="spin" bind:this={spin} class:spin-active={spinActive} class:no-spin={!spinActive}
                             style="--spin-duration: { 4 + Math.random() * 4}s; transform-style: preserve-3d;">
                            <div class="box" style="border-color: {borderColour}; border: none;">
                                <div class="box__face box__face--front" bind:this={frontFace} style=""></div>
                                <div class="box__face box__face--back" bind:this={backFace} ></div>
                                <div class="box__face box__face--right" bind:this={rightFace} ></div>
                                <div class="box__face box__face--left" bind:this={leftFace} ></div>
                                <div class="box__face box__face--top" bind:this={topFace} ></div>
                                <div class="box__face box__face--bottom" bind:this={bottomFace} ></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>

    .spin {
        width: 150px;
        height: 150px;
        transform: rotateY(50deg);
        transform-origin: 67% 0;
        transform-style: preserve-3d;
        perspective: none;
    }

    @keyframes rotating {
        from {
            transform: rotateY(0deg);
        }
        to {
            transform: rotateY(180deg);
        }
        to {
            transform: rotateY(360deg);
        }
    }

    @keyframes bouncing {
        from {
            transform: translateY(0px);
        }
        to {
            transform: translateY(-50px);
        }
        to {
            transform: translateY(0);
        }
    }

    .spin-active {
        animation: rotating var(--spin-duration) linear infinite;
        animation-delay: var(--delay);
        transform-style: preserve-3d;
        animation-fill-mode: forwards;
    }

    .no-spin {
        width: 150px;
        height: 150px;
        transform: rotateY(15deg);
        transition: rotateY 1s ease-in-out;
        transform-origin: 67% 0;
        transform-style: preserve-3d;
    }

    .bounce-active {
        animation: bouncing 3s linear infinite;
        animation-delay: var(--delay);
        transform-style: preserve-3d;
    }

    .box-group {
        transform: scale(0.15);
    }

    .glow2 {
        opacity: 0.3;
        transform: scale(1);
    }

    .glowSvg {
        position: absolute;
        top: -50px;
        left: -50px;
        transform: translateZ(-200px) translateY(100px);
    }

    .scene {
        width: 200px;
        height: 200px;
        margin: 80px;
        perspective: 900px;
    }

    .box {
        width: 200px;
        height: 200px;
        position: relative;
        transform-style: preserve-3d;
        transition: transform 1s;
        perspective: none;
    }

    .box__face {
        position: absolute;
        border: 12px solid black;
        border-color: inherit;
        font-size: 40px;
        font-weight: bold;
        text-align: center;
    }

    .box__face--front,
    .box__face--back {
        width: 200px;
        height: 200px;
    }

    .box__face--right {
        width: 200px;
        height: 200px;
        left: -50px;
    }

    .box__face--left {
        width: 200px;
        height: 200px;
        left: 50px;
    }

    .box__face--top {
        width: 200px;
        height: 200px;
    }

    .box__face--bottom {
        width: 200px;
        height: 200px;
    }

    .box__face--front {
        background: rgb(38, 42, 51);
    }

    .box__face--right {
        background: rgb(38, 42, 51);
    }

    .box__face--back {
        background: rgb(38, 42, 51);
    }

    .box__face--left {
        background: rgb(38, 42, 51);
    }

    .box__face--top {
        background: rgb(38, 42, 51);
    }

    .box__face--bottom {
        background: rgb(38, 42, 51);
    }

    .box__face--front {
        transform: rotateY(0deg) translateZ(100px);
        perspective: none;
    }

    .box__face--back {
        transform: rotateY(180deg) translateZ(100px);
        perspective: none;
    }

    .box__face--right {
        transform: rotateY(90deg) translateZ(150px);
        perspective: none;
    }

    .box__face--left {
        transform: rotateY(-90deg) translateZ(150px);
        perspective: none;
    }

    .box__face--top {
        transform: rotateX(90deg) translateZ(100px);
        perspective: none;
    }

    .box__face--bottom {
        transform: rotateX(-90deg) translateZ(100px);
        perspective: none;
    }

    label {
        margin-right: 10px;
    }

    .spin2 {
        width: 150px;
        height: 150px;
        transform-style: preserve-3d;
        transform-origin: 67% 0;
        margin: 150px 50px;
    }

    .scene {
        transform: rotateX(-30deg);
        transform-style: preserve-3d;
        perspective: none;
    }
</style>